import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { adminReviewShifts } from './keys'
import {
  getAdminReviewShiftsForReview,
  GetAdminReviewShiftsOptions,
  GetAdminReviewShiftsResponse,
} from 'api/review'

export function useAdminReviewShifts(
  options?: GetAdminReviewShiftsOptions
): UseQueryResult<GetAdminReviewShiftsResponse> {
  return useQuery<GetAdminReviewShiftsResponse>({
    queryKey: [...adminReviewShifts, options],
    queryFn: async () => {
      return getAdminReviewShiftsForReview(options || {})
    },
  })
}
